import React from 'react'
import "../MaintenanceMode.css"
const MaintenanceMode = ({text}) => {
    return (
        <div className='maintenance'>
            <div class="gears-container">
                <div class="gear-rotate"></div>
                <div class="gear-rotate-left"></div>
            </div>
            <h1>وبسایت در حال بروزرسانی میباشد</h1>
            <p>{text}</p>
        </div>
    )
}

export default MaintenanceMode